import { recordPath, recordRoute } from '@/shared/registry'

/** Where the plan tag pages live. */
export const planTagsPath = '/entitlements/plan-tags'
export const createPlanTagPath = `${planTagsPath}/new`
export const planTagRoute = recordRoute('entitlements', 'plan-tags')
export const editPlanTagRoute = `${planTagRoute}/edit`

/** A plan tag's details page. */
export function planTagPath(id: string): string {
  return recordPath('entitlements', 'plan-tags', id)
}

/** A plan tag's edit page. */
export function editPlanTagPath(id: string): string {
  return `${planTagPath(id)}/edit`
}

/** The base of Plan Tag Details' slots (`detailsSlots`). */
export const planTagDetailsSlot = 'entitlements.plan-tag-details'

/** The permissions the plan tag screens show or hide their actions by. */
export const readPlanTagsPermission = 'entitlements.plan-tags.read'
export const writePlanTagsPermission = 'entitlements.plan-tags.write'
export const deletePlanTagsPermission = 'entitlements.plan-tags.delete'

/** The API's plan tag endpoints. */
export const planTagsApi = '/entitlements/v1/plan-tags'

export function planTagApi(id: string): string {
  return `${planTagsApi}/${encodeURIComponent(id)}`
}
